import { captureError } from '@src/utils/errors'
import { tokenRequest } from '@src/utils/http-clients/cfeAuthApi'
import { createLogic } from 'redux-logic'
import { getType } from 'typesafe-actions'
import { getPaidMember } from '../auth/selectors'
import { getDocument, showGatedComments } from '../document/actions'
import { getFeedbackIsAvailable } from '../expertcheck/selectors'
import { HideModalPayload } from '../modals/actions'
import { RootState } from '../types'
import { getIsWorkspaceActive, getUploadId } from '../workspace/selectors'
import { gainEntitledChecks, paymentSuccess } from './actions'

export const gainsEntitledChecksLogic = createLogic<RootState>({
  type: getType(gainEntitledChecks),
  validate({ getState, action }, allow, reject) {
    const state = getState()
    const paidStatusChange = getPaidMember(state)
    const workspaceActive = getIsWorkspaceActive(state)
    if (paidStatusChange && workspaceActive) {
      return allow(action)
    }
    reject(action)
  },
  process(_, dispatch, done) {
    dispatch(showGatedComments({}))
    done()
  },
})

export const paymentSuccessLogic = createLogic<RootState, HideModalPayload>({
  type: getType(paymentSuccess),
  async validate({ action }, allow, reject) {
    try {
      await tokenRequest({ refreshPaidStatus: true })
    } catch (error) {
      captureError(new Error(`Failed to refresh token for entitled checks: ${error}`))
      return reject(action)
    }
    allow(action)
  },
  process({ getState }, dispatch, done) {
    dispatch(gainEntitledChecks())

    const state = getState()
    if (getFeedbackIsAvailable(state)) {
      dispatch(getDocument.request({ id: getUploadId(state) }))
    }

    done()
  },
})

export const paymentLogic = [gainsEntitledChecksLogic, paymentSuccessLogic]



// WEBPACK FOOTER //
// ./src/state/payment/logic.ts